module.exports = __webpack_public_path__ + "img/payment_alipay.623c0ecb.png";